import useOnClickOutside from "./ClickOutside.hook";

export default useOnClickOutside;
